import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';

class IsASAPCountEqualToZero implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const principals = application.principals || [];
    const yesCount = principals.reduce((acc, p) => {
      return p?.applicant_same_as_principal === 'Yes' ? acc + 1 : acc;
    }, 0);

    return yesCount === 0;
  }
}

export default new IsASAPCountEqualToZero();
